import AppRoute from 'App/PrivateRoute';
import NoLicense from 'containers/InventoriesManagement/NoLicense';
import { useUser } from 'containers/Users';
import { useInventoryModuleAccess } from 'hooks/inventories/useInventoryModuleAccess';
import { InventoryLoadingSkeleton, isInventoryMfeEnabled } from 'mfe/remotes/inventory';
import { isEarlyPlan } from 'utils/plans';

import { InventoriesRemoteRoutes } from './InventoriesRemoteRoutes';
import { InventoryRoutes } from './InventoriesRoutes';

const INVENTORIES_PATH = '/inventories';

/**
 * Single entry for `/inventories`: decides between no access, the Early demo, the legacy module
 * and the microfrontend.
 *
 * The user is awaited before choosing, because falling back to legacy while it loads would flash
 * the wrong module for Early and V2 accounts. Early wins over V2: an Early org in V2 still sees
 * the demo.
 *
 * The inventory license is checked here and not only inside the legacy module, so an organization
 * moved to V2 without the license gets the demo instead of the microfrontend.
 */
export const InventoriesEntry = () => {
  const { hasLicense, isModuleEnabled } = useInventoryModuleAccess();
  const { data: user, isLoading } = useUser();

  if (!isModuleEnabled) {
    return <AppRoute accessRoute={false} component={NoLicense} path={INVENTORIES_PATH} />;
  }

  if (!hasLicense) {
    return <AppRoute component={NoLicense} path={INVENTORIES_PATH} />;
  }

  if (isLoading) {
    return <AppRoute component={InventoryLoadingSkeleton} path={INVENTORIES_PATH} />;
  }

  if (isEarlyPlan(user)) {
    return <AppRoute component={NoLicense} path={INVENTORIES_PATH} />;
  }

  if (!isInventoryMfeEnabled()) {
    return <InventoryRoutes />;
  }

  return <InventoriesRemoteRoutes />;
};
